import React, {useState} from "react";
import {Row} from "antd";
import moment from "moment";
import ExcelButtons from "./Components/ExcelButtons";
import Filters from "./Components/Filters";
import {useFetch} from "../../hooks/useFetch";
import stores from "../../store/stores";
import DataTable from "./Components/DataTable";

const DayOff = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [reloadData, setReloadData] = useState({});
    const [filters, setFilters] = useState({
        city: "all",
        approveStatus: "waitingApprove",
        period: "choose",
        startDate: moment().toDate(),
        endDate: moment()
            .add(1, "d")
            .toDate(),
        searchText: undefined
    });

    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.shiftStore.getDayOffList.bind(null, {
            limit: 10,
            skip: (currentPage - 1) * 10,
            city: filters.city,
            approveStatus: filters.approveStatus,
            period: filters.period,
            startDate: filters.startDate,
            endDate: filters.endDate,
            searchText: filters.searchText
        }),
        dependencies: [filters, currentPage, reloadData]
    });

    return (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            <Row justify="end">
                <ExcelButtons
                    {...filters}
                    skip={(currentPage - 1) * 10}
                    limit={10}
                    setReloadData={() => setReloadData(!reloadData)}
                />
            </Row>
            <Row style={{marginTop: 16}}>
                <DataTable
                    loading={loading}
                    data={data?.rows || []}
                    setData={setData}
                    dataCount={data?.dataCount}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setReloadData={() => setReloadData(!reloadData)}
                />
            </Row>
        </div>
    );
};

export {DayOff};
